export const NEC_SALES_ORDER_STAND_NUMBER_ATTR_NAME = 'NEC_SALES_ORDER_STAND_NUMBER';
export const NEC_DOCUMENTATION_FILE_LINK_ATTR_NAME = 'NEC_DOCUMENTATION_FILE_LINK';
export const NEC_SELECTED_TIME_SLOT_ID_ATTR_NAME = 'NEC_SELECTED_TIME_SLOT_ID';
export const NEC_SELECTED_TIME_SLOT_FROM = 'NEC_SELECTED_TIME_SLOT_FROM';
export const NEC_SELECTED_TIME_SLOT_TO = 'NEC_SELECTED_TIME_SLOT_TO';
export const NEC_SELECTED_TIME_SLOT_TEXT_ATTR_NAME = 'NEC_SELECTED_TIME_SLOT_TEXT';
export const NEC_SELECTED_FRINGE_ID_ATTR_NAME = 'NEC_SELECTED_FRINGE_ID';
export const NEC_SELECTED_FRINGE_DESCRIPTION_ATTR_NAME = 'NEC_SELECTED_FRINGE_DESCRIPTION';
export const NEC_LAST_PRICE_UPDATE_TIME = 'NEC_LAST_PRICE_UPDATE_TIME';
